/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Provider/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Provider({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Provider"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let appointmentBookingProviderNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'provider_name',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let appointmentBookingAssistantNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'assistant_name',
})
  return (<React.Fragment
>
<div
  data-testid="Provider.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z15DKuC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="regular"
 color={dtColorsNeutral600}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 display="block"
 data="appointment_booking.provider_name"
 text={appointmentBookingProviderNameValueData}
 title={appointmentBookingProviderNameValueData}
/>
<div
  data-testid="Provider.Horizontal:1"
  data-view-path={viewPath}
 style={{'--w-2-Z15DKuC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-3-Z15DKuC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-4-Z15DKuC': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal1}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="regular"
 overflowX="hidden"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 display="block"
 color={dtColorsNeutral600}
 data="appointment_booking.assistant_name"
 text={appointmentBookingAssistantNameValueData}
 title={appointmentBookingAssistantNameValueData}
/>
</div>
{children}
</React.Fragment>)
}